import hgpTailCargoDialog from './main';

export default {
  install(Vue) {
    Vue.component(hgpTailCargoDialog.name, hgpTailCargoDialog);
  },
};

